import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import AnimatedCursor from "react-animated-cursor";
import Confetti from "react-confetti";
import Cookies from "universal-cookie";
import { nanoid } from "nanoid";
import axios from "axios";
import { useNetworkState } from "react-use";
import { UAParser } from "ua-parser-js";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import "./App.css";

import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import DotsAnimation from "./Helpers/DotsAnimation";
import Home from "./Pages/Home";
import Experties from "./Pages/Experties";
import Services from "./Pages/Services";
import Projects from "./Pages/Projects";
import GPTChat from "./Components/GPTChat/GPTChat";
import Loader from "./Components/Loader/Loader";
import Wifi from "./Components/Wifi/Wifi";
import ScrollLineHeader from "./Components/ScrollLineHeader/ScrollLineHeader";
import P404 from "./Components/P404/P404";
import BlockPage from "./Components/BlockPage/BlockPage";
import BottomButton from "./Components/Button/BottonButton";
import Contacts from "./Pages/Contacts";

gsap.registerPlugin(ScrollTrigger);

const App = () => {
  const cookies = new Cookies();
  const [loading, setLoading] = useState(true);
  const [loading2] = useState(false);
  const [publicIP, setPublicIP] = useState("");
  const [identity] = useState(nanoid(8));
  const [userIdentity] = useState(cookies.get("User_Identity"));
  const { online } = useNetworkState();
  const [deviceInfo, setDeviceInfo] = useState({ type: "", os: "", battery: "" });

  const MyRoutes = ["/", "/experties", "/projects", "/services", "/contact", "/chat-gpt"];
  const Location = window.location.pathname;
  const FoundOrNot = MyRoutes.includes(Location);

  let deviceType = "";
  let advancedInfo = "";
  let Battery1 = "";

  useEffect(() => {
      const detectDevice = () => {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes("mobile") ? "Mobile" : ua.includes("tablet") ? "Tablet" : "Desktop/Laptop";
    };

    const advancedDetection = () => {
      const parser = new UAParser();
      const device = parser.getDevice();
      const os = parser.getOS();
      return {
        device: device.type || "Unknown Device",
        brand: device.vendor || "Unknown Brand",
        os: `${os.name} ${os.version}` || "Unknown OS",
      };
    };

    const detectBatteryStatus = async () => {
      if ("getBattery" in navigator) {
        const battery = await navigator.getBattery();
        const level = battery.level * 100;
        const isCharging = battery.charging ? "Yes" : "No";
        return `Battery Level: ${level}% | Charging: ${isCharging}`;
      }
      return "Battery status not supported.";
    };

    deviceType = detectDevice();
    advancedInfo = advancedDetection();
    detectBatteryStatus().then((batteryStatus) => {
      Battery1 = batteryStatus;
      setDeviceInfo({
        type: deviceType,
        os: advancedInfo.os,
        battery: batteryStatus,
      });
    });

    const timer = setTimeout(() => setLoading(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleOnline = () => window.location.reload();
    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, []);

  useEffect(() => {
    const fetchPublicIP = async () => {
      const ipResponse = await axios.get("https://api.ipify.org?format=json");
      setPublicIP(ipResponse.data.ip);

      const localIdentity = JSON.parse(localStorage.getItem("User_Identity"));
      const cookieIdentity = cookies.get("User_Identity");

      if (
        cookieIdentity?.Identity === localIdentity?.Identity &&
        cookieIdentity?.Identity !== undefined &&
        localIdentity?.Identity !== null
      ) {
        await UserFind();
      } else {
        await Checker(ipResponse.data.ip);
      }
    };

    fetchPublicIP();
  }, []);

  const UserFind = async () => {
    try {
      const d2 = new Date();
      const { data } = await axios.post(`https://portfolio-server2-final.vercel.app/api/v1/userFind`, {
        User_Identity: userIdentity.Identity,
        Device_Type: deviceType,
        Device_OS: advancedInfo.os,
        Device_Battery: Battery1,
        ToString1: d2.toString(),
      });

      if (data?.User?.Role === "Block") {
        window.location.replace("https://www.youtube.com");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const Checker = async (ip) => {
    try {
      const d = new Date();
      const d2 = new Date();

      const { data } = await axios.post(`https://portfolio-server2-final.vercel.app/api/v1/checker`, {
        Ip: ip,
        Identity: `user${identity}`,
        Device_Type: deviceType,
        Device_OS: advancedInfo.os,
        Device_Battery: Battery1,
        requestedDate1: d.toLocaleDateString(),
        requestedTime1: d.toLocaleTimeString(),
        ToString1: d2.toString(),
      });

      if (!data.error) {
        localStorage.setItem("User_Identity", JSON.stringify({ Identity: `user${identity}` }));
        cookies.set("User_Identity", { Identity: `user${identity}` }, { path: "/", maxAge: 31536000 * 10 });
      }
    } catch (err) {
      console.error("Checker error:", err.message);
    }
  };

  return (
    <div className="font-serif">
      {online ? (
        <div className="dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700 hover:from-pink-500 hover:to-orange-500">
          {/* {loading && <Confetti />} */}
          {/* {loading ? (
            <Loader />
          ) : ( */}
            <Router>
              <AnimatedCursor
                innerSize={8}
                outerSize={36}
                color="#0000ff"
                outerAlpha={0.2}
                innerScale={1.5}
                outerScale={2}
                outerStyle={{ border: "5px solid blue" }}
                innerStyle={{ backgroundColor: "blue" }}
                clickables={[
                  "a",
                  'input[type="text"]',
                  'input[type="email"]',
                  'input[type="number"]',
                  'input[type="submit"]',
                  'input[type="image"]',
                  "label[for]",
                  "select",
                  "textarea",
                  "button",
                  ".link",
                ]}
              />
              <DotsAnimation />
              {FoundOrNot && <Header />}
              <ScrollLineHeader />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/experties" element={<Experties />} />
                <Route path="/services" element={<Services />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contacts loading={loading2} />} />
                <Route path="/chat-gpt" element={<GPTChat />} />
                <Route path="/*" element={<P404 />} />
              </Routes>
                  <div className='flex justify-end pr-4 bg-[#091c30] dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700 '>  <Link> <BottomButton/></Link>   </div>
              {FoundOrNot && <Footer />}
            </Router>
          {/* )} */}
        </div>
      ) : (
        <Wifi />
      )}
    </div>
  );
};

export default App;
